import type { AxiosError } from 'axios';

export function describeApiError(err: unknown): string {
  const ax = err as AxiosError<{ detail?: string | { message?: string } }> | undefined;
  const detail = ax?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object' && 'message' in detail && detail.message) {
    return String(detail.message);
  }
  return ax?.message ?? '';
}

export const BETREUUNGSMODELL_VALUES = [
  'u3_25',
  'u3_35',
  'u3_45_lt',
  'u3_45_ge',
  'ue3_25',
  'ue3_35',
  'ue3_45_lt',
  'ue3_45_ge',
  'hort_25',
  'hort_35',
  'hort_45_lt',
  'hort_45_ge',
] as const;

export type BetreuungsmodellValue = (typeof BETREUUNGSMODELL_VALUES)[number];

/** Pseudo-Modell-Schlüssel für Integrationskinder. Wird nicht im Grid als
 *  Modell-Zeile angezeigt, sondern als separate Zeile pro Gruppe. */
export const INTEGRATION_PSEUDO_MODELL = '_integration';

export function formatEuro(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(value);
}

export const MONAT_KURZ = [
  'Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun',
  'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez',
];

export function formatAktiv(ab: number | null, bis: number | null): string {
  if (ab == null && bis == null) return 'ganzjährig';
  const von = ab != null ? MONAT_KURZ[ab - 1] : 'Jan';
  const ende = bis != null ? MONAT_KURZ[bis - 1] : 'Dez';
  return `${von} – ${ende}`;
}
